import { render, staticRenderFns } from "./PostalCodeQuery.vue?vue&type=template&id=50c927de&scoped=true"
import script from "./PostalCodeQuery.vue?vue&type=script&lang=js"
export * from "./PostalCodeQuery.vue?vue&type=script&lang=js"
import style0 from "./PostalCodeQuery.vue?vue&type=style&index=0&id=50c927de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c927de",
  null
  
)

export default component.exports